<template>
  <div class="album-container">
    <div class="title-section">
      <div class="title">
        <span>团队生活</span>
      </div>
      <div class="title-line"></div>
      <div class="title-subtitle">Group Album</div>
    </div>

    <div class="table" v-loading="loading" element-loading-text="Loading..." element-loading-spinner="el-icon-loading" element-loading-background="rgba(255, 255, 255, 0.95)">
      <div
        class="item"
        v-for="(item, index) in teamLifeList"
        :key="item.id"
        :style="{ animationDelay: index * 0.08 + 's' }"
      >
        <div class="album-card" @click="routerTo(`/detail`, item)">
          <div class="card-image-wrapper">
            <el-image
              :src="item.image"
              fit="cover"
              class="card-image"
            />
            <div class="image-overlay">
              <i class="el-icon-eye"></i>
            </div>
            <div class="image-badge">{{ item.title }}</div>
          </div>
          <div class="card-content">
            <div class="card-info">
              <time class="card-time">{{ item.createdTime | formatDate("YYYY-MM-DD") }}</time>
            </div>
            <div class="card-action">
              <span>查看详情</span>
              <i class="el-icon-arrow-right"></i>
            </div>
            <div class="card-decoration"></div>
          </div>
        </div>
      </div>

      <div v-if="!loading && teamLifeList.length === 0" class="empty-state">
        <div class="empty-icon">
          <i class="el-icon-image"></i>
        </div>
        <p class="empty-text">No photos found</p>
        <p class="empty-hint">No team life records available</p>
      </div>
    </div>
  </div>
</template>

<script>
import { getTeamLifePage } from '@/api/api'
export default {
  data () {
    return {
      type: '',
      total: 1000,
      currPage: 1,
      pageSize: 99999,
      teamLifeList: [],
      loading: true
    }
  },
  created () {
    const type = this.$route.query.type
    console.log(type)
    this.type = type
    this.getTeamLifePage()
  },
  methods: {
    routerTo (path, row) {
      sessionStorage.detail = JSON.stringify(row)
      this.$router.push({
        path
      })
    },
    currentChange (e) {
      console.log(e)
      this.currPage = e
      this.getNoticePage()
    },
    getTeamLifePage () {
      this.loading = true
      let data = {
        pageSize: this.pageSize,
        currPage: this.currPage
      }
      getTeamLifePage(data).then(res => {
        if (res.code === 200) {
          this.teamLifeList = res.data.list
          this.total = res.data.totalCount
        }
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>

<style scoped>
.album-container {
  min-height: 600px;
}

.title-section {
  position: relative;
  margin-bottom: 32px;
}

.title {
  font-size: 36px;
  line-height: 1.4;
  color: #2f4f4f;
  font-weight: 700;
  letter-spacing: 3px;
  animation: titleFloatIn 0.8s cubic-bezier(0.22, 1, 0.36, 1) forwards;
}

@keyframes titleFloatIn {
  from {
    opacity: 0;
    transform: translateY(-40px);
    letter-spacing: 10px;
  }
  to {
    opacity: 1;
    transform: translateY(0);
    letter-spacing: 3px;
  }
}

.title-line {
  position: absolute;
  bottom: -8px;
  left: 0;
  width: 80px;
  height: 4px;
  background: linear-gradient(90deg, #2f4f4f, #5a8a8a);
  border-radius: 2px;
  animation: lineSlideIn 1s cubic-bezier(0.22, 1, 0.36, 1) 0.3s forwards;
  transform-origin: left;
  transform: scaleX(0);
}

@keyframes lineSlideIn {
  from {
    transform: scaleX(0);
  }
  to {
    transform: scaleX(1);
  }
}

.title-subtitle {
  position: absolute;
  right: 0;
  top: 10px;
  font-size: 14px;
  color: #888;
  letter-spacing: 8px;
  text-transform: uppercase;
  animation: subtitleFadeIn 0.8s cubic-bezier(0.22, 1, 0.36, 1) 0.5s forwards;
  opacity: 0;
}

@keyframes subtitleFadeIn {
  from {
    opacity: 0;
    transform: translateX(20px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

.table {
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
}

.item {
  width: calc(33.333% - 16px);
  opacity: 0;
  animation: cardSlideIn 0.7s cubic-bezier(0.22, 1, 0.36, 1) forwards;
}

@keyframes cardSlideIn {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.album-card {
  background: #fff;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(47, 79, 79, 0.06);
  border: 1px solid rgba(47, 79, 79, 0.08);
  transition: all 0.4s cubic-bezier(0.22, 1, 0.36, 1);
  cursor: pointer;
}

.album-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 16px 40px rgba(47, 79, 79, 0.15);
  border-color: rgba(47, 79, 79, 0.15);
}

.card-image-wrapper {
  position: relative;
  width: 100%;
  height: 220px;
  overflow: hidden;
}

.card-image {
  width: 100%;
  height: 100%;
  transition: transform 0.5s cubic-bezier(0.22, 1, 0.36, 1);
}

.album-card:hover .card-image {
  transform: scale(1.08);
}

.image-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(47, 79, 79, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.album-card:hover .image-overlay {
  opacity: 1;
}

.image-overlay i {
  font-size: 36px;
  color: #fff;
}

.image-badge {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 12px 16px;
  background: linear-gradient(transparent, rgba(0, 0, 0, 0.7));
  color: #fff;
  font-size: 14px;
  font-weight: 500;
  backdrop-filter: blur(2px);
}

.card-content {
  padding: 16px 20px;
}

.card-info {
  display: flex;
  align-items: center;
}

.card-time {
  font-size: 13px;
  color: #888;
}

.card-action {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 6px;
  margin-top: 12px;
  color: #2f4f4f;
  font-size: 13px;
  font-weight: 500;
  transition: all 0.3s ease;
}

.album-card:hover .card-action {
  color: #3d5a5a;
  transform: translateX(5px);
}

.card-action i {
  font-size: 14px;
}

.card-decoration {
  height: 2px;
  background: linear-gradient(90deg, rgba(47, 79, 79, 0.15) 0%, rgba(47, 79, 79, 0.05) 100%);
  border-radius: 1px;
  margin-top: 12px;
}

.empty-state {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 80px 20px;
  animation: emptyFadeIn 0.6s ease forwards;
}

@keyframes emptyFadeIn {
  from {
    opacity: 0;
    transform: scale(0.95);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

.empty-icon {
  width: 100px;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #f0f0f0 0%, #e0e0e0 100%);
  border-radius: 50%;
  margin-bottom: 24px;
}

.empty-icon i {
  font-size: 48px;
  color: #aaa;
}

.empty-text {
  font-size: 18px;
  color: #666;
  margin: 0 0 8px;
}

.empty-hint {
  font-size: 14px;
  color: #999;
  margin: 0;
}

@media (max-width: 1200px) {
  .item {
    width: calc(50% - 12px);
  }
}

@media (max-width: 768px) {
  .item {
    width: 100%;
  }
}
</style>
